// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3k51Q","boxTitle":"Qualiphy_boxTitle__3MiH_","box":"Qualiphy_box__emo2z","toggleWrap":"Qualiphy_toggleWrap__Uy68E"};